import _ from 'lodash';

export const selectify = (list) => {
	const options = [];
	list.map((element, i) => options.push({value: element.id, label: element.name}));
	return options;
};

// Expect lat as string value ranging from -90 to +90
export const validateLat = (lat, onSuccess, onError) => {
	//^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$
	const re = /^[-+]?([1-8]?\d(,\d+)?|90(,0+)?),?$/;
	if ( lat === "" || lat === "-" || re.test(lat) ) return onSuccess(lat.replace(",", "."));
	return onError("Formato inválido!");
};

// Expect lat as string value ranging from -180 to +180
export const validateLng = (lng, onSuccess, onError) => {
	//^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$
	const re = /^[-+]?(180(,0+)?|((1[0-7]\d)|([1-9]?\d))(,\d+)?),?$/;
	if ( lng === "" || lng === "-" || re.test(lng) ) return onSuccess(lng.replace(",", "."));
	return onError("Formato inválido!");
};

export const parseLatLng = (value) => value.replace(/\./g, ",");

export const GPStoDecimal = (value) => {
	const last = value.slice(-1);
	const split = value.replace(/[^\d]/g, "#").split("#");
	const num = parseInt(split[0]) + (parseInt(split[1]) / 60) + (parseInt(split[2]) / 3600);
	const signal = last === "S" || last === "W" ? -1 : 1;
	return (signal * num).toString();
};

export const shouldUpdatePoint = (basePoint, newPoint) => {
	const c1 = basePoint.lat === "" ||
		basePoint.lat === "-" ||
		Math.abs(parseFloat(newPoint.lat) - parseFloat(basePoint.lat)) >= 0.000001;

	const c2 = basePoint.lng === "" ||
		basePoint.lng === "-" ||
		Math.abs(parseFloat(newPoint.lng) - parseFloat(basePoint.lng)) >= 0.000001;

	return c1 && c2;
};

export const disableOpenFileInBrowser = () => {
	// Prevent from accidentaly opening file on browser
	window.addEventListener("dragover", function(e) {
		e = e || event;
		e.preventDefault();
	}, false);
	window.addEventListener("drop", function(e) {
		e = e || event;
		e.preventDefault();
	}, false);
};

export const getBackgroundColor = (groupId) => {
	switch (groupId) {
		case 0:
			return 'brown';
		case 1:
			return 'orange';
		case 2:
			return 'purple';
		case 4:
			return 'darkgreen';
		case 5:
			return 'green';
		case 6:
			return 'steelblue';
		case 7:
			return 'blueviolet';
		case 8:
			return 'darkred';
		case 9:
			return 'pink';
		case 10:
			return 'maroon';
		case 11:
			return 'blue';
		case 12:
			return 'lightseagreen';
		case 13:
			return 'black';
		case 14:
			return 'red';
		case 15:
			return 'darkslategrey';
		case 16:
			return 'grey';
		case 17:
			return 'indianred';
		case 19:
			return 'chocolate';
		case 20:
			return 'seagreen';
		case 21:
			return 'mediumblue';
		case 22:
			return 'lightsteelblue';
		case 23:
			return 'deepskyblue';
		case 24:
			return 'darkkhaki';
		case 25:
			return 'mediumspringgreen';
		case 26:
			return 'darkkhaki';
		case 27:
			return 'sandybrown';
		case 28:
			return 'cadetblue';
		case 29:
			return 'teal';
		case 30:
			return 'darkslategray';
		case 31:
			return 'sienna';

		default:
			return 'white';
	}
};

export const getGroupInitials = (groupId) => {
	switch (groupId) {
		case 0: // Público
			return 'P';
		case 1: // Jurídico
			return 'Ju';
		case 2: // Reposidtorio Dinamico de documentos
			return 'RD';
		case 4: // Avaliação Geotécnica
			return 'Ge';
		case 5: // Qualidade da Água - Conformidade
			return 'A2';
		case 6: // Avaliação da Infraestrutura Física
			return 'IF';
		case 7: // Avaliação das Estruturas de Concreto
			return 'EC';
		case 8: // Avaliação da Zona Estuarina e Costeira
			return 'ZC';
		case 9: // Avaliação dos Danos Ambientais
			return 'Da';
		case 10: // Biodiversidade
			return 'Bi';
		case 11: // Qualidade da Água - Caracterização
			return 'A1';
		case 12: // Qualidade dos Sedimentos - Caracterização
			return 'S1';
		case 13: // Qualidade dos Sedimentos - Conformidade
			return 'S2';
		case 14: // Intervenções em Esgotamento Sanitário
			return 'ES';
		case 15: // Abastecimento de Água
			return 'AA';
		case 16: // Resíduos Sólidos Urbanos
			return 'RS';
		case 17: // Impactos Socioeconômicos
			return 'IS';
		case 19: // COPPE
			return 'CO';
		case 20: // Vale
			return 'Va';
		case 21: // Fundação Renova
			return 'FR';
		case 22: // Avaliacao e Monitoramento da Obra de Dragagem
			return 'AD';
		case 23: // Análise do Pescado na Costa
			return 'PC';
		case 24: // Análise do Relatorio Ramboll
			return 'RR';
		case 25: // Analise do Relatório Lactec
			return 'RL';
		case 26:
			return 'AO';
		case 27:
			return 'AR'; // Biota Aquática e Comunidade Ripárias - AR
		case 28:
			return 'AG'; // Avaliação Geoquímica - AG
		case 29:
			return 'MP'; // Metais Pesados em Sedimentos, Água e Solos
		case 30:
			return 'SA'; // Suporte e Aprimoramento GeoDocs
		case 31:
			return 'QA'; //Avaliação da Qualidade da Água
		default:
			return '';
	}
};

export const filterByKeywords = (documents, keywords) => {
	return documents.filter((d) => {
		for ( let i = 0; i < d.keywords.length; i++ ) {
			if ( keywords.indexOf(d.keywords[i]) > -1 ) return true;
		}
		return false;
	});
};

export const isArrayDifferent = (left, right) => {
	const leftComp = _.differenceWith(left, right, (a, b) => a.id === b.id).length > 0;
	const rightComp = _.differenceWith(right, left, (a, b) => a.id === b.id).length > 0;

	return leftComp || rightComp;
};

export const buildQueryString = (...parameters) => {
	let query = [];
	parameters.map((param) => {
		let key, value;
		const entries = Object.entries(param);
		
		if (entries.length > 1) Error('Each arg must have a single member.');

		[key, value] = entries[0];
		query.push(`${key}=${value}`);
	});

	return query.join('&');
};


// WEBPACK FOOTER //
// ./src/businessLogic/util.js